/** The Profile section that holds a person's email preferences. */
export const sectionId = 'email-notifications';

/** Where every email's "Manage email preferences" link and the unsubscribe page send people. */
export const path = `/profile?section=${sectionId}`;
